import React, { useState } from 'react';
import { Input } from 'semantic-ui-react';

import { EyeToggleIcon } from './EyeToggleIcon';

import './css/index.css';

export type Props = {
  autoComplete?: 'off' | 'on' | 'new-password';
  dataTestId?: string;
  error?: boolean;
  id?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  withToggle?: boolean;
  strengthMeter?: (p: string) => number; // 0...4
  onChange?: any;
  onBlur?: any;
};

export const PasswordField: React.FC<Props> = ({
  autoComplete = 'on',
  dataTestId = 'password-field',
  error = false,
  id = 'password',
  label = '',
  placeholder = '',
  withToggle = false,
  value,
  strengthMeter,
  onChange,
  onBlur,
}) => {
  const [visible, setVisible] = useState(false);
  const [innerValue, setInnerValue] = useState('');

  let withStrength = false;
  let strengthScore = 0;

  if (strengthMeter) {
    withStrength = true;
    strengthScore = strengthMeter(value || innerValue);
  }

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <Input
        autoComplete={autoComplete}
        data-test={dataTestId}
        error={error}
        id={id}
        placeholder={placeholder}
        type={visible ? 'text' : 'password'}
        value={value || innerValue}
        onChange={onChange || ((e) => setInnerValue(e.currentTarget.value))}
        onBlur={onBlur}
        icon={
          withToggle ? (
            <EyeToggleIcon
              visible={visible}
              onClick={() => setVisible(!visible)}
            />
          ) : (
            ''
          )
        }
      />
      {withStrength && (
        <>
          <span className="strength" data-score={strengthScore} />
          <div className="judgement">{strengthScore < 2 ? '　' : 'OK'}</div>
        </>
      )}
    </>
  );
};
